'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_ImageEditor$Dialog$() {
  this.lr = null;
  this.nC = null;
  this.mD = false;
  this.dv = 0;
  this.al = null;
  this.nB = 0;
  this.jj = 0;
  this.oO = null;
  this.oP = false;
  this.oQ = null;
  this.oR = false;
  this.a6C = null;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_Enumeration__I__(this, 0);
  $n_Lmealorama_components_ImageEditor$Dialog$ = this;
  var name = (((this.al !== null) && this.al.l()) ? this.al.k() : "addUrl");
  this.a6C = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name);
}
export { $c_Lmealorama_components_ImageEditor$Dialog$ as $c_Lmealorama_components_ImageEditor$Dialog$ };
$p = $c_Lmealorama_components_ImageEditor$Dialog$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Enumeration();
$p.constructor = $c_Lmealorama_components_ImageEditor$Dialog$;
/** @constructor */
function $h_Lmealorama_components_ImageEditor$Dialog$() {
}
export { $h_Lmealorama_components_ImageEditor$Dialog$ as $h_Lmealorama_components_ImageEditor$Dialog$ };
$h_Lmealorama_components_ImageEditor$Dialog$.prototype = $p;
var $d_Lmealorama_components_ImageEditor$Dialog$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_ImageEditor$Dialog$, "mealorama.components.ImageEditor$Dialog$", ({
  Hl: 1,
  aX: 1,
  a: 1
}));
export { $d_Lmealorama_components_ImageEditor$Dialog$ as $d_Lmealorama_components_ImageEditor$Dialog$ };
var $n_Lmealorama_components_ImageEditor$Dialog$;
function $m_Lmealorama_components_ImageEditor$Dialog$() {
  if ((!$n_Lmealorama_components_ImageEditor$Dialog$)) {
    $n_Lmealorama_components_ImageEditor$Dialog$ = new $c_Lmealorama_components_ImageEditor$Dialog$();
  }
  return $n_Lmealorama_components_ImageEditor$Dialog$;
}
export { $m_Lmealorama_components_ImageEditor$Dialog$ as $m_Lmealorama_components_ImageEditor$Dialog$ };
//# sourceMappingURL=mealorama.components.-Image-Editor$-Dialog$.js.map
